import React from 'react';

import { Pages } from '../types';

interface LayoutProps {
  children: React.ReactNode;
  page: Pages;
  setPage: React.Dispatch<React.SetStateAction<Pages>>;
}

export const Layout = ({ children, page, setPage }: LayoutProps) => (
  <>
    <div className="navbar bg-base-200">
      <div className="navbar-start">
        {page !== Pages.Game && (
          <button className="btn btn-ghost" onClick={() => setPage(Pages.Game)}>
            Game
          </button>
        )}
      </div>
      <div className="navbar-center hidden lg:flex">
        <div className="prose">
          <h2>Learn braille</h2>
        </div>
      </div>
      <div className="navbar-end">
        {page !== Pages.Reference && (
          <button className="btn btn-ghost" onClick={() => setPage(Pages.Reference)}>
            Reference
          </button>
        )}
      </div>
    </div>
    <div className="p-8 flex justify-center w-full text-center">{children}</div>
  </>
);
